import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-2" }
const _hoisted_2 = {
  key: 0,
  class: "mr-2 flex items-center"
}
const _hoisted_3 = { class: "flex flex-col space-y-4 pt-4 sm:flex-row sm:space-y-0 sm:space-x-4" }

import Icon from '@/components/Icon.vue';
    import {
        DatePickerArrow,
        DatePickerCalendar,
        DatePickerCell,
        DatePickerCellTrigger,
        DatePickerContent,
        DatePickerField,
        DatePickerGrid,
        DatePickerGridBody,
        DatePickerGridHead,
        DatePickerGridRow,
        DatePickerHeadCell,
        DatePickerHeader,
        DatePickerHeading,
        DatePickerInput,
        DatePickerNext,
        DatePickerPrev,
        DatePickerRoot,
        DatePickerTrigger,
    } from 'reka-ui';
    import { useI18n } from 'vue-i18n';
    import { ref, watch, type Ref } from 'vue';
    import { CalendarDate } from '@internationalized/date';
    import type { DateValue } from 'reka-ui';
    import { useDateFormat } from '@/composables/useDateFormat';
    import type { HTMLAttributes } from 'vue';
    import { cn } from '@/lib/utils';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'DatePicker',
  props: {
    modelValue: {},
    disabled: { type: Boolean },
    minDate: {},
    maxDate: {},
    class: {},
    showInput: { type: Boolean, default: true }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

    const props = __props;

    const emit = __emit;

    const { parseDateString } = useDateFormat();

    // Convert string to CalendarDate if needed
    const convertToCalendarDate = (value: any): DateValue | null => {
        if (!value) return null;

        // If it's already a CalendarDate, return it
        if (value instanceof CalendarDate) {
            return value;
        }

        // If it's a string, try to parse it
        if (typeof value === 'string') {
            return parseDateString(value);
        }

        return null;
    };

    // Internal value that's always a DateValue
    const internalValue = ref<DateValue | null>(
        convertToCalendarDate(props.modelValue),
    ) as Ref<DateValue | null>;

    // Watch for external changes
    watch(
        () => props.modelValue,
        (newValue) => {
            internalValue.value = convertToCalendarDate(newValue);
        },
    );

    // Emit changes back to parent - always emit in "yyyy-mm-dd" format
    const emitValue = (value: DateValue | null) => {
        if (value) {
            // Always emit as string in "yyyy-mm-dd" format
            emit('update:modelValue', value.toString());
        } else {
            emit('update:modelValue', null);
        }
    };

    watch(internalValue, (newValue) => {
        emitValue(newValue);
    });

    if (internalValue.value) {
        emitValue(internalValue.value);
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(DatePickerRoot), {
      modelValue: internalValue.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((internalValue).value = $event)),
      locale: "da",
      disabled: _ctx.disabled,
      "min-value": _ctx.minDate,
      "max-value": _ctx.maxDate,
      "close-on-select": ""
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(DatePickerField), {
          class: _normalizeClass(
                    _unref(cn)(
                        'data-[invalid]:border-destructive border-input data-[disabled]:bg-faded flex h-7.5 w-full min-w-0 items-center rounded-md border bg-transparent px-2.5 py-1 text-xs shadow-xs transition-[color,box-shadow] outline-none',
                        props.class,
                    )
                )
        }, {
          default: _withCtx(({ segments }) => [
            (_ctx.showInput)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(segments, (item) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: item.part
                    }, [
                      (item.part === 'literal')
                        ? (_openBlock(), _createBlock(_unref(DatePickerInput), {
                            key: 0,
                            part: item.part
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.value), 1)
                            ]),
                            _: 2
                          }, 1032, ["part"]))
                        : (_openBlock(), _createBlock(_unref(DatePickerInput), {
                            key: 1,
                            part: item.part,
                            class: "data-[placeholder]:text-muted-foreground focus:bg-muted rounded-xs p-0.5 focus:outline-none"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.value), 1)
                            ]),
                            _: 2
                          }, 1032, ["part"]))
                    ], 64))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _createVNode(_unref(DatePickerTrigger), { class: "hover:text-primary ml-auto cursor-pointer rounded focus:outline-none" }, {
              default: _withCtx(() => [
                _createVNode(Icon, {
                  name: "calendar",
                  class: "size-3.5"
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_unref(DatePickerContent), {
          "side-offset": 4,
          class: "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 z-50 rounded-xl border bg-white shadow-sm will-change-[transform,opacity]"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(DatePickerArrow), { class: "fill-white stroke-gray-300" }),
            _createVNode(_unref(DatePickerCalendar), { class: "p-4" }, {
              default: _withCtx(({ weekDays, grid }) => [
                _createVNode(_unref(DatePickerHeader), { class: "flex items-center justify-between" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(DatePickerPrev), { class: "hover:bg-background text-foreground inline-flex h-7 w-7 cursor-pointer items-center justify-center rounded-md bg-transparent active:scale-98 active:transition-all" }, {
                      default: _withCtx(() => [
                        _createVNode(Icon, {
                          name: "chevronLeft",
                          class: "h-4 w-4"
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(DatePickerHeading), { class: "text-foreground font-medium" }),
                    _createVNode(_unref(DatePickerNext), { class: "hover:bg-background text-foreground inline-flex h-7 w-7 cursor-pointer items-center justify-center rounded-md bg-transparent active:scale-98 active:transition-all" }, {
                      default: _withCtx(() => [
                        _createVNode(Icon, {
                          name: "chevronRight",
                          class: "h-4 w-4"
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_3, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(grid, (month) => {
                    return (_openBlock(), _createBlock(_unref(DatePickerGrid), {
                      key: month.value.toString(),
                      class: "w-full border-collapse space-y-1 select-none"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(DatePickerGridHead), null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(DatePickerGridRow), { class: "mb-1 flex w-full justify-between" }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(weekDays, (day) => {
                                  return (_openBlock(), _createBlock(_unref(DatePickerHeadCell), {
                                    key: day,
                                    class: "text-green8 w-8 rounded-md text-xs"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(day), 1)
                                    ]),
                                    _: 2
                                  }, 1024))
                                }), 128))
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_unref(DatePickerGridBody), null, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(month.rows, (weekDates, index) => {
                              return (_openBlock(), _createBlock(_unref(DatePickerGridRow), {
                                key: `weekDate-${index}`,
                                class: "flex w-full"
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(weekDates, (weekDate) => {
                                    return (_openBlock(), _createBlock(_unref(DatePickerCell), {
                                      key: weekDate.toString(),
                                      date: weekDate
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(DatePickerCellTrigger), {
                                          day: weekDate,
                                          month: month.value,
                                          class: "data-[disabled]:text-faded-foreground data-[selected]:text-primary data-[selected]:bg-primary/10 hover:bg-primary/10 text-foreground before:bg-primary data-[today]:before:bg-primary data-[outside-view]:text-foreground/30 data-[unavailable]:text-foreground/30 relative flex h-8 w-8 items-center justify-center rounded-md border border-transparent bg-transparent text-xs font-normal whitespace-nowrap outline-none before:absolute before:top-[3px] before:hidden before:h-1 before:w-1 before:rounded-full data-[disabled]:hover:bg-transparent data-[selected]:font-medium data-[selected]:before:bg-white data-[today]:before:top-6 data-[today]:before:block data-[unavailable]:pointer-events-none data-[unavailable]:line-through"
                                        }, null, 8, ["day", "month"])
                                      ]),
                                      _: 2
                                    }, 1032, ["date"]))
                                  }), 128))
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "disabled", "min-value", "max-value"])
  ]))
}
}

})